import { ConsoleLoggingService } from "@/services/logger/console.logger";

export interface ILoggingService {
  logError(error: Error): void;
}

export const getActiveLoggingService = () => {
  return ConsoleLoggingService.getInstance();
};
